import { Region } from 'constants/shop';
import { COMMON_COLLECTION_HANDLES } from './common-handles';
import { DISCOUNT_COLLECTION_HANDLES } from './discount-handles';
import { CollectionHandles } from './types';
const OTHER_COLLECTION_HANDLES = {
  dogsAllMeatTypes: {
    [Region.DE]: 'fur-hunde-alle-fleischsorten',
    [Region.NL]: 'voor-honden-alle-vleessoorten',
  },
  catsAllMeatTypes: {
    [Region.DE]: 'fur-katzen-alle-fleischsorten',
    [Region.NL]: 'voor-katten-alle-vleessoorten',
  },
  dogsAllMeatTypesLp: {
    [Region.DE]: 'fur-hunde-alle-fleischsorten-lp',
    [Region.NL]: 'voor-honden-alle-vleessoorten-lp',
  },
  catsAllMeatTypesLp: {
    [Region.DE]: 'fur-katzen-alle-fleischsorten-lp',
    [Region.NL]: 'voor-katten-alle-vleessoorten-lp',
  },
  catsAllTexturesLp: {
    [Region.DE]: 'fur-katzen-alle-konsistenzen-lp',
    [Region.NL]: 'voor-katten-alle-consistenties-lp',
  },
  dogsWetFoodLp: { [Region.DE]: 'fur-hunde-nassfutter-lp', [Region.NL]: 'voor-honden-natvoer-lp' },
  dogsWetFoodLp2: {
    [Region.DE]: 'fur-hunde-nassfutter-lp-2',
    [Region.NL]: 'voor-honden-natvoer-lp-2',
  },
  dogsWetFoodTest: {
    [Region.DE]: 'fur-hunde-nassfutter-test',
    [Region.NL]: 'voor-honden-natvoer-test',
  },
  dogsWetFoodStorys: {
    [Region.DE]: 'fur-hunde-nassfutter-storys',
    [Region.NL]: 'voor-honden-natvoer-storys',
  },
  dogsDryFoodLp: {
    [Region.DE]: 'fur-hunde-trockenfutter-lp',
    [Region.NL]: 'voor-honden-droogvoer-lp',
  },
  dogsBarfLp: {
    [Region.DE]: 'fur-hunde-barf-frische-menus-lp',
    [Region.NL]: 'voor-honden-barf-verse-menus-lp',
  },
  dogsBarfLp2: {
    [Region.DE]: 'fur-hunde-barf-frische-menus-lp-2',
    [Region.NL]: 'voor-honden-barf-verse-menus-lp-2',
  },
  dogsSnacksLp: { [Region.DE]: 'fur-hunde-snacks-lp', [Region.NL]: 'voor-honden-snacks-lp' },
  dogsSupplementsLp: {
    [Region.DE]: 'fur-hunde-nahrungserganzung-lp',
    [Region.NL]: 'voor-honden-voedingssupplementen-lp',
  },
  dogsHealthLp: {
    [Region.DE]: 'fur-hunde-gesundheit-lp',
    [Region.NL]: 'voor-honden-gezondheid-lp',
  },
  catsWetFoodLp: { [Region.DE]: 'fur-katzen-nassfutter-lp', [Region.NL]: 'voor-katten-natvoer-lp' },
  catsDryFoodLp: {
    [Region.DE]: 'fur-katzen-trockenfutter-lp',
    [Region.NL]: 'voor-katten-droogvoer-lp',
  },
  catsBarfLp: {
    [Region.DE]: 'fur-katzen-barf-frische-menus-lp',
    [Region.NL]: 'voor-katten-barf-verse-menus-lp',
  },
  dogsAdult: { [Region.DE]: 'fur-hunde-adult', [Region.NL]: 'voor-honden-adult' },
  dogsSenior: { [Region.DE]: 'fur-hunde-senior', [Region.NL]: 'voor-honden-senior' },
  dogsSeniorLp: { [Region.DE]: 'fur-hunde-senior-lp', [Region.NL]: 'voor-honden-senior-lp' },
  dogsPuppyJuniorLp: {
    [Region.DE]: 'fur-hunde-welpen-und-junghunde-lp',
    [Region.NL]: 'voor-honden-puppys-en-jonge-honden-lp',
  },
  dogsPuppyJuniorLp1: {
    [Region.DE]: 'fur-hunde-welpen-und-junghunde-lp1',
    [Region.NL]: 'voor-honden-puppys-en-jonge-honden-lp1',
  },
  catsAdult: { [Region.DE]: 'fur-katzen-adult', [Region.NL]: 'voor-katten-adult' },
  catsSenior: { [Region.DE]: 'fur-katzen-senior', [Region.NL]: 'voor-katten-senior' },
  catsSeniorLp: { [Region.DE]: 'fur-katzen-senior-lp', [Region.NL]: 'voor-katten-senior-lp' },
  catsKitten: {
    [Region.DE]: 'fur-katzen-kitten-und-junge-katze',
    [Region.NL]: 'voor-katten-kitten-en-jonge-kat',
  },
  catsKittenLp: {
    [Region.DE]: 'fur-katzen-kitten-und-junge-katze-lp',
    [Region.NL]: 'voor-katten-kitten-en-jonge-kat-lp',
  },
  dogsSensitive: { [Region.DE]: 'fur-hunde-sensitiv', [Region.NL]: 'voor-honden-sensitief' },
  dogsSkinCoat: {
    [Region.DE]: 'fur-hunde-haut-fellprobleme',
    [Region.NL]: 'voor-honden-huid-vachtproblemen',
  },
  dogsSkinCoatLp: {
    [Region.DE]: 'fur-hunde-haut-fellprobleme-lp',
    [Region.NL]: 'voor-honden-huid-vachtproblemen-lp',
  },
  dogsDigestion: {
    [Region.DE]: 'fur-hunde-verdauungsprobleme',
    [Region.NL]: 'voor-honden-spijsverteringsproblemen',
  },
  dogsDigestionLp: {
    [Region.DE]: 'fur-hunde-verdauungsprobleme-lp',
    [Region.NL]: 'voor-honden-spijsverteringsproblemen-lp',
  },
  dogsDigestionLp1: {
    [Region.DE]: 'fur-hunde-verdauungsprobleme-lp1',
    [Region.NL]: 'voor-honden-spijsverteringsproblemen-lp1',
  },
  dogsDigestionLp2: {
    [Region.DE]: 'fur-hunde-verdauungsprobleme-lp2',
    [Region.NL]: 'voor-honden-spijsverteringsproblemen-lp2',
  },
  dogsIntolerances: {
    [Region.DE]: 'fur-hunde-unvertraeglichkeiten-allergien',
    [Region.NL]: 'voor-honden-intoleranties-allergieen',
  },
  dogsIntolerancesLp: {
    [Region.DE]: 'fur-hunde-unvertraeglichkeiten-allergien-lp',
    [Region.NL]: 'voor-honden-intoleranties-allergieen-lp',
  },
  dogsIntolerancesLp1: {
    [Region.DE]: 'fur-hunde-unvertraeglichkeiten-allergien-lp1',
    [Region.NL]: 'voor-honden-intoleranties-allergieen-lp1',
  },
  dogsIntolerancesLp2: {
    [Region.DE]: 'fur-hunde-unvertraeglichkeiten-allergien-lp2',
    [Region.NL]: 'voor-honden-intoleranties-allergieen-lp2',
  },
  dogsPickyEater: {
    [Region.DE]: 'fur-hunde-sehr-waehlerisch',
    [Region.NL]: 'voor-honden-zeer-kieskeurig',
  },
  dogsPickyEaterLp: {
    [Region.DE]: 'fur-hunde-sehr-waehlerisch-lp',
    [Region.NL]: 'voor-honden-zeer-kieskeurig-lp',
  },
  dogsPickyEaterLp1: {
    [Region.DE]: 'fur-hunde-sehr-waehlerisch-lp1',
    [Region.NL]: 'voor-honden-zeer-kieskeurig-lp1',
  },
  dogsPickyEaterLp2: {
    [Region.DE]: 'fur-hunde-sehr-waehlerisch-lp2',
    [Region.NL]: 'voor-honden-zeer-kieskeurig-lp2',
  },
  dogsPickyEaterUnaccented: {
    [Region.DE]: 'fur-hunde-sehr-wahlerisch',
    [Region.NL]: 'voor-honden-zeer-kieskeurig-2',
  },
  dogsOverweight: { [Region.DE]: 'fur-hunde-uebergewicht', [Region.NL]: 'voor-honden-overgewicht' },
  dogsGrainFree: {
    [Region.DE]: 'fur-hunde-getreidefreies-hundefutter',
    [Region.NL]: 'voor-honden-graanvrij-hondenvoer',
  },
  dogsGrainFreeLp: {
    [Region.DE]: 'fur-hunde-getreidefreies-hundefutter-ohne-getreide-lp',
    [Region.NL]: 'voor-honden-graanvrij-hondenvoer-zonder-granen-lp',
  },
  dogsHypoallergenicLp: {
    [Region.DE]: 'fur-hunde-hypoallergenes-hundefutter-lp',
    [Region.NL]: 'voor-honden-hypoallergeen-hondenvoer-lp',
  },
  dogsSugarFreeLp: {
    [Region.DE]: 'fur-hunde-ohne-zucker-lp',
    [Region.NL]: 'voor-honden-zonder-suiker-lp',
  },
  dogsHealthPrevention: {
    [Region.DE]: 'fur-hunde-gesundheitspraevention',
    [Region.NL]: 'voor-honden-gezondheidspreventie',
  },
  catsPickyEater: { [Region.DE]: 'fur-katzen-wahlerisch', [Region.NL]: 'voor-katten-kieskeurig' },
  catsMoreAcceptance: {
    [Region.DE]: 'fur-katzen-mehr-akzeptanz',
    [Region.NL]: 'voor-katten-meer-acceptatie',
  },
  catsPickyEaterLp: {
    [Region.DE]: 'fur-katzen-wahlerisch-lp',
    [Region.NL]: 'voor-katten-kieskeurig-lp',
  },
  catsPickyEaterLp1: {
    [Region.DE]: 'fur-katzen-wahlerisch-lp1',
    [Region.NL]: 'voor-katten-kieskeurig-lp1',
  },
  catsDigestion: {
    [Region.DE]: 'fur-katzen-verdauungsprobleme',
    [Region.NL]: 'voor-katten-spijsverteringsproblemen',
  },
  catsSkinCoat: {
    [Region.DE]: 'fur-katzen-haut-fellprobleme',
    [Region.NL]: 'voor-katten-huid-vachtproblemen',
  },
  catsIntolerances: {
    [Region.DE]: 'fur-katzen-unvertraeglichkeiten',
    [Region.NL]: 'voor-katten-intoleranties',
  },
  catsOverweight: { [Region.DE]: 'fur-katzen-ubergewicht', [Region.NL]: 'voor-katten-overgewicht' },
  catsNeutered: {
    [Region.DE]: 'fur-katzen-sterilisiert',
    [Region.NL]: 'voor-katten-gesteriliseerd',
  },
  catsOutdoor: { [Region.DE]: 'fur-katzen-freiganger', [Region.NL]: 'voor-katten-buitenkat' },
  catsGrainFreeLp: {
    [Region.DE]: 'fur-katzen-getreidefreies-katzenfutter-ohne-getreide-lp',
    [Region.NL]: 'voor-katten-graanvrij-kattenvoer-zonder-granen-lp',
  },
  catsHypoallergenicLp: {
    [Region.DE]: 'fur-katzen-hypoallergenes-katzenfutter-lp',
    [Region.NL]: 'voor-katten-hypoallergeen-kattenvoer-lp',
  },
  catsUseYourBenefitLp: {
    [Region.DE]: 'fur-katzen-nutze-deinen-vorteil-lp',
    [Region.NL]: 'voor-katten-profiteer-van-je-voordeel-lp',
  },
  dogsBulldog: { [Region.DE]: 'fur-hunde-bulldogge', [Region.NL]: 'voor-honden-bulldog' },
  dogsBulldogLp: { [Region.DE]: 'fur-hunde-bulldogge-lp', [Region.NL]: 'voor-honden-bulldog-lp' },
  dogsBulldogLp1: {
    [Region.DE]: 'fur-hunde-bulldogge-lp1',
    [Region.NL]: 'voor-honden-bulldog-lp1',
  },
  dogsBulldogLp2: {
    [Region.DE]: 'fur-hunde-bulldogge-lp2',
    [Region.NL]: 'voor-honden-bulldog-lp2',
  },
  dogsChihuahua: { [Region.DE]: 'fur-hunde-chihuahua', [Region.NL]: 'voor-honden-chihuahua' },
  dogsChihuahuaLp: {
    [Region.DE]: 'fur-hunde-chihuahua-lp',
    [Region.NL]: 'voor-honden-chihuahua-lp',
  },
  dogsChihuahuaLp1: {
    [Region.DE]: 'fur-hunde-chihuahua-lp1',
    [Region.NL]: 'voor-honden-chihuahua-lp1',
  },
  dogsDachshund: { [Region.DE]: 'fur-hunde-dackel', [Region.NL]: 'voor-honden-teckel' },
  dogsDachshundLp: { [Region.DE]: 'fur-hunde-dackel-lp', [Region.NL]: 'voor-honden-teckel-lp' },
  dogsDachshundLp1: { [Region.DE]: 'fur-hunde-dackel-lp1', [Region.NL]: 'voor-honden-teckel-lp1' },
  dogsHerdingDogs: {
    [Region.DE]: 'fur-hunde-huetehunde',
    [Region.NL]: 'voor-honden-herdershonden',
  },
  dogsMaltese: { [Region.DE]: 'fur-hunde-malteser', [Region.NL]: 'voor-honden-maltezer' },
  dogsMixedBreed: { [Region.DE]: 'fur-hunde-mischling', [Region.NL]: 'voor-honden-kruising' },
  dogsPoodle: { [Region.DE]: 'fur-hunde-pudel', [Region.NL]: 'voor-honden-poedel' },
  dogsRetriever: { [Region.DE]: 'fur-hunde-retriever', [Region.NL]: 'voor-honden-retriever' },
  dogsShepherd: { [Region.DE]: 'fur-hunde-schaeferhund', [Region.NL]: 'voor-honden-duitse-herder' },
  dogsSpitz: { [Region.DE]: 'fur-hunde-spitz', [Region.NL]: 'voor-honden-spits' },
  dogsTerrier: { [Region.DE]: 'fur-hunde-terrier', [Region.NL]: 'voor-honden-terrier' },
  dogsTerrierLp: { [Region.DE]: 'fur-hunde-terrier-lp', [Region.NL]: 'voor-honden-terrier-lp' },
  dogsPaidSocialTreatBox50A: {
    [Region.DE]: 'fur-hunde-paid-social-leckerbox-50-a',
    [Region.NL]: 'voor-honden-paid-social-leckerbox-50-a',
  },
  dogsPaidSocialTreatBox50B: {
    [Region.DE]: 'fur-hunde-paid-social-leckerbox-50-b',
    [Region.NL]: 'voor-honden-paid-social-leckerbox-50-b',
  },
  dogsPaidSocialTreatBox50ACh: {
    [Region.DE]: 'fur-hunde-paid-social-leckerbox-50-a-ch',
    [Region.NL]: 'voor-honden-paid-social-leckerbox-50-a-ch',
  },
  dogsWetFoodClassicBundle40: {
    [Region.DE]: 'fur-hunde-nassfutter-classic-bundle-40',
    [Region.NL]: 'voor-honden-natvoer-classic-bundle-40',
  },
  dogsTrialPacks: {
    [Region.DE]: 'fur-hunde-probierpakete',
    [Region.NL]: 'voor-honden-proefpakketten',
  },
  ...DISCOUNT_COLLECTION_HANDLES,
  petsWetFood: {
    [Region.DE]: 'fur-hunde-und-katzen-nassfutter',
    [Region.NL]: 'voor-honden-en-katten-natvoer',
  },
  petsDryFood: {
    [Region.DE]: 'fur-hunde-und-katzen-trockenfutter',
    [Region.NL]: 'voor-honden-en-katten-droogvoer',
  },
  tawkrAssortment: { [Region.DE]: 'tawkr-assortment', [Region.NL]: 'tawkr-assortment' },
  foodGuide: { [Region.DE]: 'futterguide', [Region.NL]: 'voedingsgids' },
  testCdpQa: { [Region.DE]: 'test-cdp-qa', [Region.NL]: 'test-cdp-qa' },
} as const satisfies CollectionHandles;

export const COLLECTION_HANDLES = {
  ...COMMON_COLLECTION_HANDLES,
  ...OTHER_COLLECTION_HANDLES,
};

export type CollectionHandleKey = keyof typeof COLLECTION_HANDLES;
